/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Success_TextInputs */



/**
* | output |
* | --- |
* | "Publishing was successful. Please verify the asset in Iconik before exiting." |
*
* @param {Iconik_Publish_Success_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_success_text = /** @type {((inputs?: Iconik_Publish_Success_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Success_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La publication a reussi. Veuillez verifier l'asset dans Iconik avant de quitter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Veröffentlichung war erfolgreich. Bitte überprüfen Sie das Asset in Iconik, bevor Sie das Programm beenden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblicazione avvenuta con successo. Verifica la risorsa in Iconik prima di uscire.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Публикация прошла успешно. Пожалуйста, проверьте ресурс в Iconik перед выходом.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicación exitosa. Verifique el recurso en Iconik antes de salir.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布成功。请在退出前在 Iconik 中验证资产。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("公開に成功しました。終了する前にIconikでアセットを確認してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रकाशन सफल रहा। बाहर निकलने से पहले कृपया Iconik में एसेट को सत्यापित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A publicação foi concluída com sucesso. Verifique o arquivo no Iconik antes de sair.")
	return /** @type {LocalizedString} */ ("Publishing was successful. Please verify the asset in Iconik before exiting.")
});